export default __webpack_public_path__ + "static/media/emoji-smileSick.667b0b75.svg";